import React, {
  createContext,
  type PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from "react";

type PortalContextValue = {
  container: HTMLElement | null;
};

const PortalContext = createContext<PortalContextValue>({ container: null });

export const ShadowPortalProvider = ({ children }: PropsWithChildren<unknown>) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  const value = useMemo(() => ({ container }), [container]);

  return (
    <PortalContext.Provider value={value}>
      <div
        ref={(el) => (el ? setContainer(el) : undefined)}
        className="pm-react-portal-root"
        style={{ position: "relative", width: 0, height: 0 }}
      />
      {children}
    </PortalContext.Provider>
  );
};

export const useShadowPortalContainer = (): HTMLElement | null => {
  return useContext(PortalContext).container;
};
